import React, { useEffect, useMemo, useState } from 'react';
import styles from './SettingsBody.module.css';
import SettingsNavbar from '../../Molecules/Settings/SettingsNavBar/SettingsNavbar';
import SettingsPage from '../../Template/SettingsTemplate/SettingsPage';
import {
  useFetchAllTypes,
  useFetchDropDownTypes,
  useFetchPositions,
} from '../../../Hooks/Settings';

const POSITIONS_KEY = 'positions';

const SettingsBody = () => {
  const [type, setType] = useState(1);
  const [title, setTitle] = useState('العنوان');
  const [isRelated, setIsRelated] = useState('');

  const { data: allTypes, isLoading: isTypesLoading } = useFetchAllTypes();

  const isPositions = type === POSITIONS_KEY;

  const {
    data: options,
    refetch: refetchTypes,
    isLoading: isOptionsLoading,
  } = useFetchDropDownTypes(type, { enabled: !isPositions });

  const {
    data: positions,
    isLoading: isPositionsLoading,
    refetch: refetchPositions,
  } = useFetchPositions({ enabled: isPositions });

  const allTypesWithPositions = useMemo(() => {
    const base = Array.isArray(allTypes?.data) ? allTypes.data : [];

    const positionsItem = {
      ddtypeId: POSITIONS_KEY,
      type: 'مناصب',
      isSingular: 'منصب',
      createdOn: null,
      createdBy: null,
      relatedTo: null,
    };

    const exists = base.some((x) => x.ddtypeId === POSITIONS_KEY);
    return exists ? base : [...base, positionsItem];
  }, [allTypes]);

  useEffect(() => {
    const selected = allTypesWithPositions.find((x) => x.ddtypeId === type);
    setTitle(
      selected?.isSingular ? selected?.isSingular : selected?.type || 'العنوان'
    );

    if (isPositions) {
      refetchPositions();
    } else if (type) {
      refetchTypes();
    }
  }, [
    type,
    isPositions,
    allTypesWithPositions,
    refetchTypes,
    refetchPositions,
  ]);

  const finalData = isPositions ? positions?.data : options?.data;
  const finalLoading = isPositions ? isPositionsLoading : isOptionsLoading;

  return (
    <div className={styles['settings-container']}>
      <SettingsNavbar
        setType={setType}
        allTypes={{ ...allTypes, data: allTypesWithPositions }}
        setIsRelated={setIsRelated}
        isTypesLoading={isTypesLoading}
      />

      <SettingsPage
        data={finalData}
        title={title}
        type={type}
        refetchTypes={isPositions ? refetchPositions : refetchTypes}
        isRelated={isRelated}
        isOptionsLoading={finalLoading}
      />
    </div>
  );
};

export default SettingsBody;
